export const Style = ({ colors = [] }) => (
  <g id="Estilo1_3_">
    <linearGradient
      id="SVGID_200_"
      gradientUnits="userSpaceOnUse"
      x1="75.6"
      y1="402.6861"
      x2="75.6"
      y2="406.5832"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_200_)' }}
      d="M87.2,76.2c0,0-2.3-1.3-4.4-2.4c-1.7-0.9-3.3-1.7-3.7-1.7 c-1.3,0-1.2,0.8-3.3,1c0,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0c-2.1-0.3-2-1.1-3.3-1c-0.4,0-2,0.8-3.7,1.7c-2.2,1.1-4.4,2.4-4.4,2.4 l2.8,0.9l2.7-2.2L67.3,77l1.9,0.2l1.3-1.5L69,77.7c0,0,2.9-0.7,6.6-0.8c3.7,0.1,6.6,0.8,6.6,0.8l-1.5-2.1l1.3,1.5l1.9-0.2 l-2.1-2.1l2.7,2.2L87.2,76.2z"
    />
  </g>
)
